export function flipdish(state = { Bounced: false }, action) {
  switch (action.type) {
    case 'APP_BOUNCED':
      return { Bounced: true };
    default:
      return state;
  }
}
